import { useCallback, useState } from "react";
import DialogCriacaoSazonalidade from "./DialogCriacaoEditSazonalidade";
import SessaoConfiguracao, { ConfiguracaoColunas } from "../../../../../components/BasicComponents/DisplayDados/SessaoConfiguracao";

export default function Sazonalidade() {

  const [openModal, setOpenModal] = useState<TOpenModalSazonalidade>(null)

  //funções manipuladoras
  const handleModalAction = useCallback((action: "open" | "close", id?: true | number, value?: TSazonalidade | null) => {
    if (action === "close") setOpenModal(null)
    if (action === "open" && id && value) setOpenModal({ open: id, defaultValue: value })
    if (action === "open" && id && !value) setOpenModal({ open: id, defaultValue: null })
  }, [])
  //

  return (
    <>
      <SessaoConfiguracao<TSazonalidade>
        titulo="Sazonalidade"
        endpoints={{
          listar: "estoque/configuracoes/pesquisar-sazonalidades-vendas",
          deletar: "estoque/configuracoes/excluir-sazonalidade",
        }}
        colunas={colunas}
        queryKey="pesquisar-sazonalidade"
        onEditar={(sazonalidade) => {
          handleModalAction("open", sazonalidade.id, sazonalidade)
        }}
        onAdicionar={() => {
          handleModalAction("open", true, null)
        }}
        mensagemSucessoDeletar="Sazonalidade deletada com sucesso!"
        mensagemErroDeletar="Erro ao deletar sazonalidade!"
        mensagemSemDados="Nenhuma sazonalidade encontrada."
      />
      {Boolean(openModal?.open) &&
        <DialogCriacaoSazonalidade
          defaultValue={openModal?.defaultValue ? openModal : null}
          open={Boolean(openModal?.open)}
          handleClose={() => handleModalAction("close")}
        />
      }
    </>
  );
}

export type TSazonalidade = {
  id: number;
  nome: string;
  inicio: string;
  fim: string;
  cores: string;
};

export type TOpenModalSazonalidade = {
  open: number | boolean | null;
  defaultValue: TSazonalidade | null;
} | null


const colunas: ConfiguracaoColunas<TSazonalidade>[] = [
  {
    campo: "nome",
    titulo: "Nome",
  },
];
